import  { useContext, useState, useEffect, useCallback } from "react";
import { NotificationsContext } from "@ui-components/Notifications";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import { useIntl } from "react-intl";
import {useHistory} from "react-router-dom";

export const useWorksiteTask = (task_id) => {
  const { push } = useContext(NotificationsContext);
  const intl = useIntl();
  
  const countryApiRequest = useCountryAxiosInstance();

  const [worksiteTask, setWorksiteTask] = useState();
  const history = useHistory();

  const fetchTask = useCallback(async () => {
    try {
      if (!task_id) return;
      const response = await countryApiRequest.get(
        `/worksites_tasks/${task_id}/extended`
      );
      if (!response)
        history.push('/not-found');
      setWorksiteTask(response);
    } catch (error) {
      push({
        type: "error",
        title: intl.formatMessage({ id: "an_error_occurred" }),
      });
      setWorksiteTask(false);
    }
  }, [countryApiRequest, push, intl, task_id, history]);

  useEffect(() => {
    if (task_id !== null && task_id !== undefined) {
      fetchTask();
    }
  }, [countryApiRequest, push, intl, task_id, fetchTask]);

  return {worksiteTask, setWorksiteTask, fetchTask};
};

export default useWorksiteTask;
